// Module
var code = "<ep-event-bit url=eventBit.SSO></ep-event-bit>";
// Exports
module.exports = code;